import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { APP_URL, AUTH_TYPE, DBYD_1100_URL } from 'types';
import Services from 'services';
import { GenericPageLayout } from 'layouts/genericPage.layout';
import customIcons from 'assets/icons';
import { Link } from 'carbon-components-react';
import { selectIsAuthenticated } from 'redux/session/selectors';
import { setAppLoginType, setHeaderPanelExpand } from 'redux/app/actions';
import { fetchAuthRequest } from 'redux/auth/action';
import { contactSupportFlag } from 'redux/user/actions';

export const MobilizationPage: React.FC = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const handleSSO = useCallback(() => {
    dispatch(setAppLoginType(AUTH_TYPE.SSO_LOGIN));
    dispatch(fetchAuthRequest({ context: AUTH_TYPE.SSO_LOGIN }));
  }, [dispatch]);

  const handleOpenContactSupport = useCallback(() => {
    dispatch(contactSupportFlag(true));
    dispatch(setHeaderPanelExpand({ panel: 'account', isOpen: false }));
  }, [dispatch]);

  if (process.env.REACT_APP_MOBILISATION_PHASE !== 'true') {
    return <Redirect to={APP_URL.AUTH} />;
  }

  return (
    <div
      id="mobilization"
      className={`mobilization${isAuthenticated ? ' is-auth' : ''}`}
      data-testid="mobilization"
    >
      <GenericPageLayout
        pageClassName="auth--wrapper"
        bodyFooterIcon={customIcons.CalenderDate}
      >
        <h1 className="heading--top">
          {isAuthenticated
            ? 'Thanks for signing up. Our new service is almost ready for you to enjoy in July.'
            : 'Our new service is almost ready for you to enjoy in July'}
        </h1>
        {!isAuthenticated && (
          <>
            <p className="auth--description">
              <span className="semi-bold">If you lodge enquiries</span>, you can{' '}
              <Link onClick={() => Services.auth.signupWithSSOService()}>
                sign up in advance
              </Link>{' '}
              to be ready (but you&apos;ll have to wait until July to lodge your
              first enquiries).
            </p>
            <p className="auth--description">
              <span className="semi-bold">If you’re an asset owner</span>, you
              must first{' '}
              <Link onClick={() => Services.auth.signupWithSSOService()}>
                register for an account
              </Link>{' '}
              to use the new service. Once you&apos;ve created your account, you
              can <Link onClick={() => handleSSO()}>sign in here</Link>.
            </p>
          </>
        )}
        <div className="auth--other-links">
          <Link href={DBYD_1100_URL.LOGIN_HELP} target="_blank">
            Help with registering for an account
          </Link>
          <Link href={DBYD_1100_URL.LOGIN_HELP} target="_blank">
            Help with signing in
          </Link>
          {/* <Link onClick={() => Services.auth.forgotSSOPassword()}>
            Forgot password
          </Link> */}
          <p>
            <br />
          </p>
          <Link href={DBYD_1100_URL.HELP} target="_blank">
            Help website
          </Link>
          <Link onClick={() => handleOpenContactSupport()}>
            Contact support
          </Link>
        </div>
      </GenericPageLayout>
    </div>
  );
};

MobilizationPage.displayName = 'MobilizationPage';

export default React.memo(MobilizationPage);
